'use strict';

export default class ValidationRules {
    public static between(value: number, min: number, max: number): boolean {
        return value >= min && value <= max;
    }
}
